// extracted by mini-css-extract-plugin
export default {"overlay":"photo_overlay__nmJfy","highResImage":"photo_highResImage__3pv3u"};